import { useEffect, useState } from 'react';
import batchTeacherStructureService from 'ApiService/Teacher/batch.teacher.service';
import toast from 'react-hot-toast';

const SelectBatches = ({
  setDisable,
  courses,
  setTestData,
  testData,
  loadingCourses,
}) => {
  const [errors, setErrors] = useState([]);
  const [batchStructures, setBatchStructures] = useState([]);
  const [loadingStructures, setLoadingStructures] = useState(false);

  const handleCourseChange = (event) => {
    const courseId = event.target.value;
    setTestData((prevTestData) => ({
      ...prevTestData,
      courseId,
      structureId: '',
    }));
    setBatchStructures([]);
  };

  const handleStructureChange = async (event) => {
    const structureId = event.target.value;
    setTestData((prev) => ({ ...prev, structureId }));
  };

  useEffect(() => {
    if (!testData.courseId) {
      setBatchStructures([]);
      return;
    }
    const fetchStructures = async () => {
      setLoadingStructures(true);
      try {
        const res = await batchTeacherStructureService.getBatchStructuresByCourse(testData.courseId);
        if (res.data.success) {
          setBatchStructures(res.data.batchStructures || []);
        } else {
          toast.error(res.data.message || 'Failed to load batch structures.');
        }
      } catch (err) {
        console.error('Error loading structures:', err);
        toast.error(err.response?.data?.message || 'Failed to load batch structures.');
      } finally {
        setLoadingStructures(false);
      }
    };
    fetchStructures();
  }, [testData.courseId]);

  useEffect(() => {
    const newErrors = [];
    if (!testData?.courseId) {
      newErrors.push('Please select a course.');
    }
    if (!testData?.structureId) {
      newErrors.push('Please select a batch structure.');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [setDisable, testData]);

  return (
    <div className=" w-full rounded-lg px-3 pt-7 md:px-8">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Class Information
        </h4>
      </div>

      <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>
          <select
            onChange={handleCourseChange}
            value={testData?.courseId || ''}
            name="course"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>
            {loadingCourses ? (
              <option>Loading courses...</option>
            ) : courses.length === 0 ? (
              <option className="cursor-pointer font-bold text-brand-500">
                No courses available
              </option>
            ) : (
              courses.map((course, i) => (
                <option key={course._id} value={course._id}>
                  {i + 1}. {course.courseName}
                </option>
              ))
            )}
          </select>
        </div>

        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch Structure
          </label>
          <select
            value={testData?.structureId || ''}
            onChange={handleStructureChange}
            disabled={!testData.courseId}
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white disabled:opacity-50"
          >
            <option value="">Select Structure</option>
            {loadingStructures ? (
              <option>Loading...</option>
            ) : batchStructures.length === 0 ? (
              <option>No structures available</option>
            ) : (
              batchStructures.map((bs) => (
                <option key={bs._id} value={bs._id}>
                  {bs.name}
                </option>
              ))
            )}
          </select>
        </div>
      </div>

      {errors.length > 0 && (
        <div className="mt-2 text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectBatches;
